import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { VendureAuthService } from './auth/services/vendure-auth.service';
import { PlatformService } from './core/services/platform.service';
import { LayoutComponent } from './layout/layout.component';

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected title = 'nasij-admin';
  constructor(
    private _plateForm: PlatformService,
    private vendureAuth: VendureAuthService
  ) {
    this._plateForm.setLanguage();
  }

  async ngOnInit() {
    // let token = localStorage.getItem('vendureToken');
    // if (!token) {
    // try {
    //   await this.handleLoginWithVendure();
    // } catch (error) {
    //   console.log(error);
    // }
    // }
  }

  async handleLoginWithVendure() {
    const token = await this.vendureAuth.login(
      environment.vendureVariables.username,
      environment.vendureVariables.password,
      environment.vendureVariables.rememberMe
    );
    if (token) {
      // console.log('Vendure Token:', token);
      // You can now use this token in your other API requests
    }
  }
}
